import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer 
      className="bg-[#050505] border-t border-white/5 py-16"
      data-testid="footer"
    >
      <div className="container-main">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <h3 className="font-heading text-3xl tracking-tighter text-white">
                8eight8
              </h3>
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#A3A3A3] font-subheading">
                Beverage Co
              </p>
            </Link>
            <p className="text-[#737373] text-sm leading-relaxed">
              Premium spirits crafted with passion. POG Vodka and Maduro Tequila.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-subheading text-sm tracking-[0.15em] uppercase text-white mb-6">
              Explore
            </h4>
            <ul className="space-y-3">
              {["Products", "Our Story", "Recipes", "Where to Buy"].map((item) => (
                <li key={item}>
                  <Link
                    to={`/${item.toLowerCase().replace(/\s+/g, '-').replace('our-', '')}`}
                    className="text-[#A3A3A3] hover:text-[#C8A876] transition-colors text-sm"
                    data-testid={`footer-link-${item.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-subheading text-sm tracking-[0.15em] uppercase text-white mb-6">
              Products
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/products" 
                  className="text-[#FF6B35] hover:text-[#FF8559] transition-colors text-sm"
                >
                  POG Vodka
                </Link>
              </li>
              <li>
                <Link 
                  to="/products" 
                  className="text-[#C8A876] hover:text-[#DDBD90] transition-colors text-sm"
                >
                  Maduro Tequila
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-subheading text-sm tracking-[0.15em] uppercase text-white mb-6">
              Contact
            </h4>
            <ul className="space-y-3 text-[#A3A3A3] text-sm">
              <li>
                <Link 
                  to="/contact" 
                  className="hover:text-[#C8A876] transition-colors"
                >
                  Get in Touch
                </Link>
              </li>
              <li className="text-[#737373]">
                everything@8eight8.net
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#737373] text-xs">
              © {new Date().getFullYear()} 8eight8 Beverage Co LLC. All rights reserved.
            </p>
            <p className="text-[#737373] text-xs">
              Please drink responsibly. Must be 21+ to purchase.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
